import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bell } from 'lucide-react';
import { useState } from 'react';

export default function NotificacionesPanel({ 
  notificaciones, 
  onMarcarLeida, 
  onMarcarTodasLeidas,
  onViewTarea,
  tareas
}) {
  const [notificacionesAbiertas, setNotificacionesAbiertas] = useState(false);
  const noLeidas = notificaciones.filter(n => !n.leida).length;

  return (
    <div className="relative">
      <Button 
        variant="outline" 
        onClick={() => setNotificacionesAbiertas(!notificacionesAbiertas)}
        className="relative"
      >
        <Bell className="w-4 h-4" />
        {noLeidas > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {noLeidas}
          </span>
        )}
      </Button>
      
      {notificacionesAbiertas && (
        <Card className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto z-50 shadow-lg">
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-sm">Notificaciones</CardTitle>
              {noLeidas > 0 && (
                <Button size="sm" variant="ghost" onClick={onMarcarTodasLeidas}>
                  Marcar todas como leídas
                </Button>
              )}
            </div>
          </CardHeader>
          <CardContent>
            {notificaciones.length > 0 ? (
              <div className="space-y-2">
                {notificaciones.slice(0, 10).map((notif) => (
                  <div 
                    key={notif.id} 
                    className={`p-2 rounded cursor-pointer ${
                      notif.leida ? 'bg-gray-50' : 'bg-blue-50'
                    }`}
                    onClick={() => {
                      onMarcarLeida(notif.id);
                      if (notif.tarea_id) {
                        const tarea = tareas.find(t => t.id === notif.tarea_id);
                        if (tarea) onViewTarea(tarea);
                      }
                      setNotificacionesAbiertas(false);
                    }}
                  >
                    <p className="text-sm font-semibold">{notif.titulo}</p>
                    <p className="text-xs text-gray-600">{notif.mensaje}</p>
                    <p className="text-xs text-gray-400 mt-1">
                      {new Date(notif.created_at).toLocaleString('es-ES')}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500 text-center py-4">No hay notificaciones</p>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
